import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Form, Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import { Formik } from 'formik';
import * as yup from 'yup';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';



import moment from 'moment'


import Dialog from '../../services/Dialogs'


import { labelPrivilegio, descargarArchivo } from '../../services/funcionesPublicas'


import { SERVER_ } from  '../../config';



const ModalContratoEmpleado = ( params : any ) => {


  const { show, handleClose, empleado } = params


  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
          fecha_ingreso : yup.string().required(mensajes_validacion_generico),
          fin_contrato : yup.string().required(mensajes_validacion_generico),
  });


const [ envio_server, setSeEnvio ] = useState<boolean>(false)
const enviarFormulario = async (registro:any,event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `recursos_humanos/actualizar_fecha_ingreso/${empleado.uuid}` , { fecha_ingreso : moment(registro.fecha_ingreso).format('YYYY-MM-DD') })

        if(res_){
          toast.success('Se actualizó la fecha de ingreso')
          setTimeout(()=>{
            // handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}


  return (
    <>
      <Modal show={show} size={'xl'} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Contrado de Empleado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(empleado)
          }


    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{
            fecha_ingreso : new Date(moment(empleado.fecha_ingreso).toString()),
            fin_contrato : new Date(),
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>


          <div className="row">
            <div className="col-sm-4">

              <small>Empleado</small>
              <h6>{empleado.nombres} {empleado.materno} {empleado.materno}</h6>

              <small>Rol</small>
              <h6>{labelPrivilegio(empleado.rol)}</h6>

            </div>
            <div className="col-sm-4">
              
                  <div className="mb-3">
                    <Form.Label>Fecha de Ingreso</Form.Label>
                    <DatePicker selected={values.fecha_ingreso} className="form-control" inline dateFormat="yyyy-MMMM-dd" maxDate={new Date()} onChange={(date) => setFieldValue('fecha_ingreso', date ) } />
                  </div>



            </div>
            <div className="col-sm-4">

              {
                [''].indexOf(empleado.rol) > -1 && (
                  <>
                    si si si 
                  </>
                )
              }
              
                  <div className="mb-3">
                    <Form.Label>Fecha del Fin del Contrato</Form.Label>
                    <DatePicker selected={values.fin_contrato} className="form-control" inline dateFormat="yyyy-MMMM-dd"   onChange={(date) => setFieldValue('fin_contrato', date ) } />
                  </div>


                  <p>
                    <Button onClick={(e:any)=>{descargarArchivo(`${SERVER_}recursos_humanos/contrato/${empleado.uuid}/${moment(values.fin_contrato).format('YYYY-MM-DD')}`)}} variant="link">Generar Contrato</Button>
                  </p>


            </div>
          </div>

 


        </Form>
      )}
    </Formik>




        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalContratoEmpleado;